// extracted by mini-css-extract-plugin
export default {"panelWrapper":"PanelWrapper_panelWrapper__bhQA5"};